import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {LayoutState} from "../store/layouts/types";
import {triggerDatepicker} from "../store/layouts/actions";
import {ApplicationState} from "../store";
import {resetTimestrips} from "../store/timeline/actions";
import {TimelineState} from "../store/timeline/types";
import CalendarComponent from "../components/footer/CalendarComponent";


const CalendarContainer = () => {
    const dispatch = useDispatch();
    const { datePickerIsOpened } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const { time } = useSelector<ApplicationState, TimelineState>(state => state.timeline);

    const applyHandler = (newDate: any) => {
        if (newDate instanceof Date) {
            const date = newDate.valueOf() > Date.now() ? Date.now() : newDate.valueOf();
            dispatch(resetTimestrips(date));
            dispatch(triggerDatepicker(!datePickerIsOpened));
        }
    };

    const cancelHandler = () => {
        dispatch(triggerDatepicker(false))
    };

    return (
        <>
            {
                datePickerIsOpened &&
                    <CalendarComponent
                        time={new Date(time)}
                        applyHandler={applyHandler}
                        cancelHandler={cancelHandler}
                    />
            }
        </>
    )
};

export default CalendarContainer